import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar as BSNavbar, Nav, Container, Button } from 'react-bootstrap';
import ContactModal from './ContactModal';

function NavbarComponent() {
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const collapseRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <BSNavbar 
      expand="lg" 
      fixed="top" 
      className={`navbar ${scrolled ? 'scrolled' : ''}`}
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      <Container>
        <BSNavbar.Brand as={Link} to="/">
          <img 
            src={process.env.PUBLIC_URL + '/logo.png'} 
            alt="6G AI Sweden AB" 
            height="50"
            style={{ objectFit: 'contain' }}
            loading="lazy"
          />
        </BSNavbar.Brand>
        <BSNavbar.Toggle aria-controls="main-navbar" />
        <BSNavbar.Collapse id="main-navbar" ref={collapseRef}>
          <Nav className="ms-auto align-items-center gap-3">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''}
              onClick={handleNavClick}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/services" 
              className={location.pathname === '/services' ? 'active' : ''}
              onClick={handleNavClick}
            >
              Services
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/infrastructure" 
              className={location.pathname === '/infrastructure' ? 'active' : ''}
              onClick={handleNavClick}
            >
              Infrastructure
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/news" 
              className={location.pathname === '/news' ? 'active' : ''}
              onClick={handleNavClick}
            >
              News
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/about" 
              className={location.pathname === '/about' ? 'active' : ''}
              onClick={handleNavClick}
            >
              About
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/contact" 
              className={location.pathname === '/contact' ? 'active' : ''}
              onClick={handleNavClick}
            >
              Contact
            </Nav.Link>
            <Button variant="primary" onClick={() => setShowModal(true)} className="navbar-cta btn-primary">
              Get Started
            </Button>
          </Nav>
        </BSNavbar.Collapse>
      </Container>
      <ContactModal show={showModal} onHide={() => setShowModal(false)} />
    </BSNavbar>
  );
}

export default NavbarComponent;
